import React, { useState, useEffect } from "react";
import {
  FaFacebookSquare,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import emailjs from "emailjs-com";
import { useAuth } from "../../context/AuthContext";

const Help = () => {
  const { currentUser } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (currentUser) {
      setName(currentUser.displayName);
      setEmail(currentUser.email);
    }
  }, [currentUser]);

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_6tl10be",
        "template_1y2ycz6",
        e.target,
        "guC4PSxaEdtDCHTTS"
      )
      .then(
        (result) => {
          console.log(result.text);
          setSuccessMessage("Your message has been sent successfully!");
          setErrorMessage("");
        },
        (error) => {
          console.log(error.text);
          setSuccessMessage("");
          setErrorMessage("Failed to send message. Please try again later.");
        }
      );
  };

  return (
    <section className="bg-gray-100 py-12">
      <div className="mt-[40px] mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <div className="bg-white shadow-lg rounded-lg p-8">
              <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
                Get In Touch
              </h2>
              <p className="text-gray-600 mb-8 text-center">
                Have questions or suggestions? Let us know!
              </p>
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 gap-6 w-[80%]">
                  <div>
                    <input
                      type="text"
                      name="to_name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="form-input w-full py-3 px-4 rounded-lg bg-gray-200 focus:outline-none focus:bg-white"
                      placeholder="Your Name"
                      disabled={true}
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="user_email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-input w-full py-3 px-4 rounded-lg bg-gray-200 focus:outline-none focus:bg-white"
                      placeholder="Your Email"
                      disabled={true}
                      required
                    />
                  </div>
                  <div>
                    <textarea
                      name="message"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      className="form-textarea w-full py-3 px-4 rounded-lg bg-gray-200 focus:outline-none focus:bg-white resize-none"
                      rows="5"
                      placeholder="Your Message"
                      required
                    ></textarea>
                  </div>
                </div>
                <button
                  type="submit"
                  className="bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 mt-8 rounded-lg transition duration-300 ease-in-out"
                >
                  Send Message
                </button>
              </form>
              {successMessage && (
                <p className="text-green-600 mt-4">{successMessage}</p>
              )}
              {errorMessage && (
                <p className="text-red-600 mt-4">{errorMessage}</p>
              )}
            </div>
          </div>
          <div>
            <div className="bg-[#7171ec] text-white rounded-lg p-8">
              <h3 className="text-2xl font-bold mb-6">Follow Us</h3>
              <ul className="flex space-x-6">
                <li>
                  <a
                    href="#"
                    className="text-xl text-white hover:text-[#ff8989] transition duration-300 ease-in-out"
                  >
                    <FaFacebookSquare />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-xl text-white hover:text-[#ff8989] transition duration-300 ease-in-out"
                  >
                    <FaInstagram />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-xl text-white hover:text-[#ff8989] transition duration-300 ease-in-out"
                  >
                    <FaTwitter />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-xl text-white hover:text-[#ff8989] transition duration-300 ease-in-out"
                  >
                    <FaLinkedin />
                  </a>
                </li>
              </ul>
              <div className="mt-8">
                <h3 className="text-2xl font-bold mb-6">Contact Info</h3>
                <div className="flex items-center mb-4">
                  <FaPhoneAlt className="mr-4 text-xl" />
                  <span className="text-lg">+92 316 5721269</span>
                </div>
                <div className="flex items-center mb-4">
                  <FaEnvelope className="mr-4 text-xl" />
                  <span className="text-lg">info@collabpro.com</span>
                </div>
                <div className="flex items-center">
                  <FaMapMarkerAlt className="mr-4 text-xl" />
                  <span className="text-lg">
                    123 Main Street, Anytown, City State 123456, Pakistan
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Help;
